import { Component, OnInit } from '@angular/core';
import { ProgramService } from '../../services/program.service';
import { Observable } from 'rxjs/Observable';
import { Program } from '../../interfaces/program.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  mockData: Program[];

  constructor(private _programService: ProgramService) {}

  ngOnInit() {
    this._programService.get().subscribe(data => {
      this.mockData = data.map(a => {
        return <Program>{
          id: a.id,
          number: a.volgorde,
          name: a.naam,
          estimated: a.begroot,
          realised: a.gerealiseerd,
          forecast: a.prognose,
          space: a.ruimte,
          red: a.red,
          green: a.green,
          orange: a.orange,
          imageUrl: a.ImageUrl,
        };
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts